<template>
  <div class="relative w-full h-full overflow-y-auto p-4">
    <div v-if="!currentContract.id" class="bg-white rounded-lg p-4">
      <span class="font-bold">{{ $t('Keine Verträge vorhanden.') }}</span
      >
    </div>
    <div v-if="currentContract.id">

      <div class="w-full grid md:grid-cols-2 gap-4">
        <div
          v-for="contract in contracts"
          :key="contract.id"
          class="shadow-lg rounded-lg p-4 bg-white flex flex-col"
        >
          <!-- Name as headline -->
          <div class="mb-1">
            <span class="block text-xl font-bold">{{ contract.name }}</span>
            <span class="block text-sm text-gray-600">{{ contract.project }}</span>
          </div>
          <!-- Weekdays section -->
          <div class="mt-2 mb-3">
            <span class="font-bold">{{ getCurrentWeekString() }}</span>
            <div class="flex flex-col gap-1">
              <div class="flex justify-between items-center border-b pb-1 font-semibold text-sm text-gray-700 bg-gray-100 rounded-t px-1">
                <span class="w-20">{{ $t('Wochentag') }}</span>
                <span class="w-24 text-center">{{ $t('Abholzeit') }}</span>
                <span class="flex-1 text-left pl-2">{{ $t('Kommentar') }}</span>
              </div>
              <div v-for="weekday in getDisplayWeekdays()" :key="weekday" >
                <div class="flex justify-between items-center pb-1" :class="{'border-b': !contract.weekOverview[weekday].ade}">
                  <span class="font-semibold w-20">{{ weekdayShort(weekday) }}</span>
                  <span v-if="!contract.weekOverview[weekday].ade || !contract.weekOverview[weekday].ade.closed" class="w-24 text-center" :class="{ 'text-red-500 font-bold': contract.weekOverview[weekday].status != 'confirmed' }">{{ contract.weekOverview[weekday].pickupTime || '-' }}</span>
                  <span v-else class="w-24 text-center text-red-500 font-bold">{{ $t('Geschlossen') }}</span>
                  <span class="flex-1 text-left pl-2">{{ contract.weekOverview[weekday].reason || '' }}</span>
                </div>
                <div v-if="contract.weekOverview[weekday].ade" class="">
                  <span class="w-20"></span>
                  <span class="w-24 text-center"></span>
                  <span class="flex-1 text-left font-bold text-red-500">{{ contract.weekOverview[weekday].ade.comment }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Small action buttons -->
          <div class="flex flex-row gap-2 mt-2">
            <button
              class="px-2 py-1 text-xs rounded bg-primary text-white"
              @click="() => handleSickButton(contract)">
            {{ $t('Krankmeldung') }}</button>
            <button class="bg-primary text-white px-2 py-1 text-xs rounded" @click.stop="() => openModal('exception', contract)">{{ $t('Ausnahme') }}</button>
            <button class="bg-primary text-white px-2 py-1 text-xs rounded" @click.stop="() => openModal('timeChange', contract)">{{ $t('Abholzeit ändern') }}</button>
          </div>
          
        </div>
      </div>
      <div class="bg-white rounded-lg py-4 pl-4 w-full mt-4">
        <span class="font-bold text-xl">{{ $t('Übersicht') }}</span><br />
        <span class="font-bold" v-if="requests.length == 0">{{ $t('Keine Anfragen vorhanden.') }}</span
        >
        <table v-else>
          <thead>
            <tr>
              <th>{{ $t('Kind') }}</th>
              <th>{{ $t('Art') }}</th>
              <th>{{ $t('Tag') }}</th>
              <th>{{ $t('Neue Zeit') }}</th>
              <th>{{ $t('Grund') }}</th>
              <th>{{ $t('Status') }}</th>
              <th>{{ $t('Kommentar') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="request in requests" :key="request.id">
              <td>{{ request.name }}</td>
              <td>{{ request.kind }}</td>
              <td>{{ request.day }}</td>
              <td>{{ request.newTime }}</td>
              <td class="max-w-52">{{ request.reason }}</td>
              <td>{{ request.status }}</td>
              <td>{{ request.comment }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ChangePickupModal
        :show="showModal"
        :mode="modalMode"
        :contract="modalContract || currentContract"
        @close="showModal = false; getRequests(); getContracts()"
      />
    </div>
  </div>
</template>

<style scoped>
label {
  display: block;
  font-weight: bold;
}
table {
  max-width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

tr:nth-child(even) {
  background-color: #e6e6e6;
  /* Set the background color for even rows */
}
</style>
<script>
// @ is an alias to /src
import API from "@/API";
import ChangePickupModal from './ChangePickupModal.vue';
export default {
  name: "Mealplanning",
  components: {
    ChangePickupModal,
  },
  data() {
    return {
      requests: [],
      contracts: [],
      currentContract: {},
      toast: "",
      toastStatus: false,
      showModal: false,
      modalMode: '',
      modalContract: null,
    };
  },

  methods: {
    getDisplayWeekdays() {
      // Returns weekdays for this week, or next week if today is Sat/Sun
      const today = new Date();
      let weekdays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag'];
      // If today is Saturday (6) or Sunday (0), shift to next week
      if (today.getDay() === 6 || today.getDay() === 0) {
        // Could add logic for next week's dates if needed
        return weekdays;
      }
      return weekdays;
    },
    weekdayShort(day) {
      // Returns short version (Mo, Di, Mi, Do, Fr)
      return {
        'Montag': 'Mo',
        'Dienstag': 'Di',
        'Mittwoch': 'Mi',
        'Donnerstag': 'Do',
        'Freitag': 'Fr',
      }[day] || day;
    },
    openModal(mode, contract = null) {
      this.modalMode = mode;
      this.showModal = true;
      this.modalContract = contract;
    },
    handleSickButton(contract) {
        this.openModal('sick', contract);
    },
    handleSick({ contract, date, comment }) {
      API.requestPickupChange(
        {
          contract: contract.id,
          type: 'sick',
          date,
          comment,
        },
        (r, status) => {
          if (status === 200) {
            this.$emit('toast', this.$t('Krankmeldung gesendet!'));
            this.getRequests();
          }
        }
      );
    },
    handleException({ contract, date, time, reason }) {
      API.requestPickupChange(
        {
          contract: contract.id,
          type: 'exception',
          date,
          time,
          reason,
        },
        (r, status) => {
          if (status === 200) {
            this.$emit('toast', this.$t('Ausnahme gesendet!'));
            this.getRequests();
          }
        }
      );
    },
    handlePickupTimeChange({ contract, weekday, newTime, reason }) {
      API.requestPickupChange(
        {
          contract: contract.id,
          type: 'pickupTimeChange',
          weekday,
          newTime,
          reason,
        },
        (r, status) => {
          if (status === 200) {
            this.$emit('toast', this.$t('Abholzeit-Änderung gesendet!'));
            this.getRequests();
          }
        }
      );
    },
    selectContract(contract) {
      this.currentContract = contract;
    },
    getRequests() {
      let vm = this;
      API.getPickupChangeRequests((r, status) => {
        if (status === 200) {
          vm.requests = r;
        }
      });
    },
    getContracts() {
      let vm = this;
      API.getPickupContracts((r, status) => {
        if (status === 200) {
          vm.contracts = r;
          if (vm.contracts.length > 0) {
            vm.selectContract(vm.contracts[0]);
          }
        }
      });
    },
    getCurrentWeekOfYear() {
      let date = new Date();
      let dayOfWeek = date.getDay();
      let daysToAdd = dayOfWeek === 0 ? -3 : 4 - dayOfWeek; // days to add for thursday
      let thursdayOfWeek = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + daysToAdd
      );
      console.log(thursdayOfWeek);
      let firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      daysToAdd =
        firstDayOfYear.getDay() === 0 ? -3 : 4 - firstDayOfYear.getDay();
      let firstThursdayOfYear = new Date(
        firstDayOfYear.getFullYear(),
        0,
        1 + daysToAdd
      );
      let days =
        Math.floor(
          (thursdayOfWeek - firstThursdayOfYear) / (24 * 60 * 60 * 1000)
        ) + 1;
      return Math.floor(days / 7) + 1;
    },
    getWeekDates(weekNumber) {
      const year = new Date().getFullYear();
      const jan1 = new Date(year, 0, 1);
      const firstDayOfWeek = (jan1.getDay() + 6) % 7; // Adjust so Monday = 0
      const daysOffset = (weekNumber - 1) * 7 - firstDayOfWeek;
      const startDate = new Date(jan1);
      startDate.setDate(jan1.getDate() + daysOffset);

      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 4); // Assuming work weeks of 5 days

      const startDateStr = startDate.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
      });
      const endDateStr = endDate.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
      });

      return `${startDateStr} - ${endDateStr}`;
    },
    getCurrentWeekString(){
      this.currentWeek = this.getCurrentWeekOfYear();
      return "KW " + this.currentWeek + " (" + this.getWeekDates(this.currentWeek) + ")";
    }
  },
  created() {
    this.getContracts();
    this.getRequests();
    this.year = new Date().getFullYear();
   
  },
};
</script>